import React from "react";

import {
    TableContainer,
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableRow,
} from '@mui/material';

import PhoneMissedIcon from '@mui/icons-material/PhoneMissed';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import PhoneForwardedIcon from '@mui/icons-material/PhoneForwarded';

import Utils from "../utils";

const Statistic = ({abandoned, answered, talkTime}) => {
    return(
        <span>
           
            {answered>=0&&
                <span>
                    <PhoneForwardedIcon style={{fontSize: '0.7rem', color: '#ed6d03', paddingLeft: 5}}/>
                    <span style={{paddingLeft: 5}}>{answered} </span>
                </span>
            }
            {abandoned>=0&&
                <span>
                    <PhoneMissedIcon style={{fontSize: '0.7rem', color: '#ff5722', paddingLeft: 5}}/> 
                    <span style={{paddingLeft: 5}}>{abandoned}</span>
                </span>
            }
            {talkTime>=0&&
                <span>
                   <AccessTimeIcon style={{fontSize: '0.7rem', color: '#31708f', paddingLeft: 5}}/>
                   <span style={{paddingLeft: 5}}>{Utils.secondsToTime(talkTime)}</span>
                </span>
            }
        </span>

    )
}

const Ounbounds = ({outbounds}) => {
    return(
        <TableContainer>
                <Table size="small" stickyHeader className="pc-dash-queues-table" aria-label="sticky table">
                    <TableHead>
                        <TableRow>
                            <TableCell/>
                            <TableCell/>
                            <TableCell/>
                            <TableCell/>
                            <TableCell/>
                            <TableCell/>
                            <TableCell/>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {outbounds.map((record, key) =>{
                            let backgroundColor = 'none';
                            let color = '';
                            if(record.sessions.connected > 0){
                                backgroundColor = '#dff0d8';
                                color = "#3c763d"
                            }else if(record.sessions.dialing>0){
                                backgroundColor = '#fffae1';
                                color = "#8a6d3b"
                            }
                            return(
                                <TableRow hover tabIndex={-1} key={key} style={{backgroundColor}}>
                                    <TableCell>
                                        <div style={{color}}>{record.name}</div>
                                    </TableCell>
                                    <TableCell>
                                        <Statistic {...record.statistics}/>
                                    </TableCell>
                                    <TableCell>
                                        {record.online}
                                    </TableCell>
                                    <TableCell>
                                        {record.available}
                                    </TableCell>
                                    <TableCell>
                                        {record.sessions.requests}
                                    </TableCell>
                                    <TableCell>
                                        {record.sessions.connected}
                                    </TableCell>
                                    <TableCell>
                                        {record.sessions.dialing}
                                    </TableCell>
                                </TableRow>
                            )
                        })}
                    </TableBody>
                </Table>
        </TableContainer>
    )   
}

export default Ounbounds;